/* SELF hero z zakladkami: przelaczanie zakladek (wzorzec ARIA tabs), crossfade zdjec
   i szklany napis (SVG). Opis i decyzje: sections/self-hero-tabs.liquid. */
if (!customElements.get('self-hero-tabs')) {
  customElements.define(
    'self-hero-tabs',
    class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('.sht__panel'));
        this.slides = Array.from(this.querySelectorAll('.sht__slide'));
        this.contents = Array.from(this.querySelectorAll('.sht__content'));
        this.index = 0;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktop = window.matchMedia('(min-width: 750px)');
        this.glass = this.querySelector('[data-glass]');

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.activate(i));
          tab.addEventListener('keydown', (e) => this.onKey(e, i));
        });

        /* Edytor motywu: wybor bloku pokazuje jego zakladke. */
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.tabs.indexOf(e.target);
          if (i > -1) this.activate(i);
        });

        /* Zdjecia pozostalych zakladek dociagamy dopiero po zaladowaniu strony -
           wczesniej konkurowalyby o lacze ze zdjeciem LCP. */
        this.whenLoaded().then(() =>
          setTimeout(() => {
            this.slides.slice(1).forEach((s) => {
              const img = s.querySelector('img');
              if (img) img.loading = 'eager';
            });
          }, 1200)
        );

        this.initVideo();
        if (this.glass) this.initGlass();
        this.initPause();
      }

      /* ---------- Wideo zakladki ---------- */

      /* Film gra tylko w aktywnej zakladce, na ekranie, po `load` (nie konkuruje z LCP),
         bez pauzy klientki, bez prefers-reduced-motion i bez oszczedzania danych.
         Do startu widac zdjecie zakladki (wrapper z opacity 0 do zdarzenia `playing`). */
      initVideo() {
        this.videos = Array.from(this.querySelectorAll('[data-sht-video] video'));
        if (!this.videos.length) return;
        this.saveData = !!(navigator.connection && navigator.connection.saveData);
        this.inView = true;
        this.videoReady = false;
        this.videos.forEach((v) => {
          v.muted = true;
          v.addEventListener('playing', () => v.parentElement.classList.add('is-playing'));
        });
        this.whenLoaded().then(() => {
          this.videoReady = true;
          this.syncVideo();
        });
        this.desktop.addEventListener('change', () => this.syncVideo());
        this.reduced.addEventListener('change', () => this.syncVideo());
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) =>
            entries.forEach((e) => {
              this.inView = e.isIntersecting;
              this.syncVideo();
            })
          ).observe(this);
        }
      }

      videoAllowed() {
        return !this.reduced.matches && !this.saveData;
      }

      /* Film aktywnej zakladki dla biezacej szerokosci ekranu (komputer / telefon / wspolny). */
      activeVideo(slide = this.slides[this.index]) {
        if (!this.videos || !this.videos.length || !slide || !this.videoAllowed()) return null;
        const want = this.desktop.matches ? 'd' : 'm';
        const wrap = Array.from(slide.querySelectorAll('[data-sht-video]')).find(
          (w) => w.dataset.shtVideo === want || w.dataset.shtVideo === 'all'
        );
        return wrap ? wrap.querySelector('video') : null;
      }

      syncVideo() {
        if (!this.videos || !this.videos.length) return;
        const active =
          this.videoReady && this.inView && !this.userPaused ? this.activeVideo() : null;
        this.videos.forEach((v) => {
          if (v !== active && !v.paused) v.pause();
        });
        if (active && active.paused) {
          const p = active.play();
          if (p && p.catch) p.catch(() => {});
        }
        this.updateGlass();
      }

      /* WCAG 2.2.2: pauza przesuwanego napisu. Stan wspolny z karuzela hero
         (sessionStorage 'self-animacje-pauza'); brak dostepu do storage = start bez pauzy. */
      initPause() {
        this.pauseBtn = this.querySelector('[data-sht-pause]');
        if (!this.pauseBtn) return;
        let saved = false;
        try {
          saved = window.sessionStorage.getItem('self-animacje-pauza') === '1';
        } catch (e) {
          saved = false;
        }
        this.setUserPaused(saved, false);
        this.pauseBtn.addEventListener('click', () => this.setUserPaused(!this.userPaused, true));
      }

      setUserPaused(on, remember) {
        this.userPaused = on;
        this.classList.toggle('is-user-paused', on);
        if (this.pauseBtn) this.pauseBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        this.syncVideo();
        if (!remember) return;
        try {
          if (on) window.sessionStorage.setItem('self-animacje-pauza', '1');
          else window.sessionStorage.removeItem('self-animacje-pauza');
        } catch (e) {
          /* storage niedostepny - pauza dziala do przeladowania strony */
        }
      }

      syncPauseButton() {
        if (!this.pauseBtn) return;
        const glassMoving = this.glass && !this.glass.hasAttribute('hidden') && !this.reduced.matches;
        const moving = glassMoving || !!this.activeVideo();
        this.pauseBtn.hidden = !moving;
      }

      whenLoaded() {
        return new Promise((resolve) => {
          if (document.readyState === 'complete') resolve();
          else window.addEventListener('load', resolve, { once: true });
        });
      }

      onKey(e, i) {
        const last = this.tabs.length - 1;
        let next = null;
        if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        this.tabs[next].focus();
        this.activate(next);
      }

      activate(i) {
        if (i === this.index || !this.slides[i]) return;
        const prev = this.slides[this.index];
        const next = this.slides[i];
        this.index = i;

        this.tabs.forEach((t, k) => {
          const on = k === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        const tab = this.tabs[i];
        const bar = tab && tab.parentElement;
        if (bar && bar.scrollWidth > bar.clientWidth) {
          bar.scrollTo({
            left: tab.offsetLeft - (bar.clientWidth - tab.offsetWidth) / 2,
            behavior: this.reduced.matches ? 'auto' : 'smooth',
          });
        }
        this.panels.forEach((p, k) => (p.hidden = k !== i));
        this.contents.forEach((c, k) => (c.hidden = k !== i));

        next.hidden = false;
        const img = next.querySelector('img');
        const show = () =>
          requestAnimationFrame(() => {
            if (this.slides[this.index] !== next) return;
            this.slides.forEach((s) => s.classList.toggle('is-active', s === next));
            const hideOld = () => {
              if (!prev.classList.contains('is-active')) prev.hidden = true;
            };
            if (this.reduced.matches) hideOld();
            else setTimeout(hideOld, 650);
          });
        if (img && !img.complete) {
          img.loading = 'eager';
          (img.decode ? img.decode() : Promise.resolve()).then(show, show);
        } else {
          show();
        }

        if (this.videos && this.videos.length) this.syncVideo();
        else this.updateGlass();
      }

      /* ---------- Szklany napis ---------- */

      initGlass() {
        const g = this.glass;
        this.gImg = g.querySelector('.sht__glass-img');
        this.gVeil = g.querySelector('.sht__glass-veil');
        this.gTexts = Array.from(g.querySelectorAll('.sht__glass-text'));
        this.gProbe = g.querySelector('.sht__glass-probe');
        this.speed = parseFloat(this.dataset.speed) || 70;
        this.sizePct = parseFloat(this.dataset.size) || 24;
        this.posPct = parseFloat(this.dataset.pos) || 45;
        this.glassMobile = this.dataset.glassMobile === 'true';
        this.glassReady = false;

        const fonts = document.fonts ? document.fonts.ready : Promise.resolve();
        Promise.all([fonts, this.whenLoaded()]).then(() => {
          this.glassReady = true;
          this.updateGlass();
        });
        this.desktop.addEventListener('change', () => this.updateGlass());
        this.reduced.addEventListener('change', () => this.syncPauseButton());

        /* Poza ekranem animacja stoi - filtr SVG kosztuje przy kazdej klatce. */
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) =>
            entries.forEach((e) => this.classList.toggle('is-paused', !e.isIntersecting))
          ).observe(this);
        }
      }

      updateGlass() {
        this.renderGlass();
        this.syncPauseButton();
      }

      renderGlass() {
        if (!this.glass || !this.glassReady) return;
        const g = this.glass;
        const slide = this.slides[this.index];
        const onDesktop = this.desktop.matches;
        const text = (slide.dataset.marquee || '').trim();
        const url = onDesktop ? slide.dataset.glassD : slide.dataset.glassM;
        const W = parseFloat(onDesktop ? slide.dataset.glassDw : slide.dataset.glassMw);
        const H = parseFloat(onDesktop ? slide.dataset.glassDh : slide.dataset.glassMh);
        /* Pod filmem soczewka pokazywalaby nieruchome zdjecie - napis chowamy. */
        const underVideo = !!this.activeVideo(slide);
        if (!text || !url || !W || !H || underVideo || (!onDesktop && !this.glassMobile)) {
          g.toggleAttribute('hidden', true);
          return;
        }

        /* viewBox = wymiary obrazu, wiec `slice` kadruje SVG dokladnie jak
           object-fit: cover kadruje zdjecie pod spodem - litery trafiaja w te same piksele. */
        g.setAttribute('viewBox', `0 0 ${W} ${H}`);
        this.gImg.setAttribute('href', url);
        this.gImg.setAttribute('width', W);
        this.gImg.setAttribute('height', H);
        /* Lekkie powiekszenie wnetrza liter = efekt soczewki. */
        this.gImg.setAttribute('transform', `translate(${W / 2} ${H / 2}) scale(1.07) translate(${-W / 2} ${-H / 2})`);
        this.gVeil.setAttribute('width', W);
        this.gVeil.setAttribute('height', H);

        const family =
          getComputedStyle(this).getPropertyValue('--self-font-display').trim() || 'sans-serif';
        const size = (H * this.sizePct) / 100;
        const y = (H * this.posPct) / 100 + size * 0.36;
        const sep = '   ';
        const style = (t) => {
          t.setAttribute('font-family', family);
          t.setAttribute('font-weight', '700');
          t.setAttribute('font-size', size);
          t.setAttribute('letter-spacing', -size * 0.02);
        };

        /* Pomiar wymaga WYRENDEROWANEGO SVG - przy [hidden] (display:none)
           getComputedTextLength() zwraca 0 i napis nigdy by sie nie pokazal. */
        g.toggleAttribute('hidden', false);
        style(this.gProbe);
        this.gProbe.textContent = text + sep;
        const unit = this.gProbe.getComputedTextLength();
        if (!unit) {
          g.toggleAttribute('hidden', true);
          return;
        }
        const repeats = Math.ceil(W / unit) + 2;
        const line = (text + sep).repeat(repeats);
        this.gTexts.forEach((t) => {
          style(t);
          t.setAttribute('x', 0);
          t.setAttribute('y', y);
          t.textContent = line;
        });
        g.style.setProperty('--sht-shift', `${-unit}px`);
        g.style.setProperty('--sht-dur', `${(unit / this.speed).toFixed(2)}s`);
        g.toggleAttribute('hidden', false);
      }
    }
  );
}
